import {VariantConfigT} from '@/lib/types/colors.types';

export const cyanConfig: VariantConfigT = {
  basic: {
    icon: 'cyan',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'cyan',
    active: 'cyan',
  },
  outline: {
    icon: 'cyan',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'cyan',
    iconHover: 'cyan',
    iconActive: 'cyan',
    hover: 'cyan',
    active: 'cyan',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
